import http from './http';
import { API_PATHS } from '@/config/api';

export default {
  // Admin-Dashboard-Statistiken abrufen
  getDashboard() {
    return http.get(API_PATHS.ADMIN_DASHBOARD);
  },
  
  // Firmenliste abrufen
  getCompanies(params = {}) {
    return http.get(API_PATHS.ADMIN_COMPANIES, { params });
  },
  
  // Firma erstellen
  createCompany(companyData) {
    return http.post(API_PATHS.ADMIN_COMPANIES, companyData);
  },
  
  // Firma aktualisieren
  updateCompany(id, companyData) {
    return http.put(`/api/admin/companies/${id}`, companyData);
  },
  
  // Firma löschen
  deleteCompany(id) {
    return http.delete(`/api/admin/companies/${id}`);
  }
}; 